<template>
	<div class="mainBox">
		<div class="topNav">
			<van-nav-bar safe-area-inset-top :placeholder="true" :fixed="true" title="旁站详情" left-text="返回" left-arrow @click-left="goBack">
			</van-nav-bar>
		</div>
		<div class="detailFullCenter">
			<div class="notesTop">
				<div class="patrolTitle">{{record.subjectName}}</div>
			</div>
			<div class="patrolDesc">部位：{{record.onsitePosition}}</div>
			<div class="patrolDesc">项目：{{record.onsiteItem}}</div>
			<div class="patrolTime">开始时间：{{record.beginTime}}</div>
			<div class="patrolDesc">{{record.onsiteContent}}</div>
			<div class="patrolTime">旁站人：{{record.bystander}}</div>
			<div class="patrolTime">参与人：{{record.participants}}</div>
		</div>
		<div style="margin: 16px;">
			<van-button round block type="info" @click="goBack()">返回</van-button>
		</div>
	</div>
</template>
<script>
	import { info } from '../../api/qualityStation'
	import { Notify } from 'vant';
	import common from '../../utils/common';

	export default {
		name: 'qualitySideStationDetail',
		data() {
			return {
				// 项目名称
				projectName: '',
				record: '',
				id: ""
			}
		},
		mounted() {
			this.project = common.getProject();
			if(this.project == null || this.project == undefined){
				Notify({ type: 'danger', message: '获取项目信息失败' });
			}
			this.projectName = this.project.projectName
			this.id = this.$route.query.id;
			this.getDetail(this.id)
		},
		methods: {
			getDetail(id){
				info(id).then(response => {
					if(response.data.resultCode != 200) {
						Notify({ type: 'danger', message: response.data.resultMessage });
						return
					}
					this.record = response.data.body
				})
			},
			goBack() {
				this.$router.push({
					name: 'qualitySideStationList'
				});
			}
		}
	}
</script>
<style lang="scss" src="@/assets/sass/common.scss"></style>